import { ApiError } from "@steto-care/steto-query";
import { Outlet, createRootRoute } from "@tanstack/react-router";

import { HandledErrorCard } from "@/uiKit/organisms/HandledErrorCard.tsx";
import { LoadingPage } from "@/uiKit/pages/LoadingPage.tsx";

export const Route = createRootRoute({
  component: Outlet,
  pendingComponent: LoadingPage,
  wrapInSuspense: true,
  errorComponent: HandledErrorCard,
  notFoundComponent: () => (
    <HandledErrorCard error={new ApiError({ error: "PAGE_NOT_FOUND", statusCode: 0 })} reset={() => {}} />
  ),
});
